import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import MaterialDashboardPage from '../../../../sales-kit/components/Library/pages/performance';

import { ModulePermissionProps } from '../../../../../common/module/types';

export const SystemConfig = {
  blockName: 'component.formTitle.happy-share-material',
  blockType: 'happyShareMaterialPerformance',
  moduleType: 'HappyShare',
};

const PerformancePage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return <MaterialDashboardPage {...props} {...SystemConfig} />;
};

export default PerformancePage;
